import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthTabComponent } from './auth-tab/auth-tab.component';
import { LoggedGuardServiceService } from '../logged-guard-service.service';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordResetVerificationComponent } from './password-reset-verification/password-reset-verification.component';
import {SignupComponent} from './signup/signup.component';

const routes: Routes = [
    {
        path: '',
        component: AuthTabComponent, // Replace with Public Page
        canActivate: [LoggedGuardServiceService],
        children: [
            {
                path: 'login',
                component: LoginComponent
            },
            {
                path: 'register',
                component: SignupComponent
            }
        ]
    },
    {
        path: 'password-reset',
        component: PasswordResetComponent,
        canActivate: [LoggedGuardServiceService]
    },
    {
        path: 'password-verification',
        component: PasswordResetVerificationComponent,
        canActivate: [LoggedGuardServiceService]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PublicRoutingModule {}
